import { get } from 'api/get';

import _ from 'lodash';

import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

export const ROI_GET_VENDORDATA_REQUEST = 'roi/get/vendordata/request';
export const ROI_GET_VENDORDATA_SUCCESS = 'roi/get/vendordata/success';
export const ROI_GET_VENDORDATA_FAILURE = 'roi/get/vendordata/failure';


export function getVendorsData() {
  return async (dispatch) => {
    dispatch({
      type: ROI_GET_VENDORDATA_REQUEST,
      payload: null
    });

    try {
      const req = await get('vendors/modeling/meta');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: ROI_GET_VENDORDATA_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ROI_GET_VENDORDATA_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}
